'use strict';/* global define */define('modules/core/modules/utils/services/promise-util/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$q", "ng"];
function factory($q,ng){// jshint validthis:true
// jshint latedef:false
return{allResources:allResources,getResolvedResource:getResolvedResource,getRejectedResource:getRejectedResource};// ---
/**
     * Get a promise to be resolved when handing in an object
     * including different ng-ressource object
     *
     * @param  {Object} object    - object including ngResource properties
     * @param  {Array|undefined}  - keys to be waiten for
     * @return {Promise}          - promise to be resolved when resources
     *                              are resolved
     * @tested
     */function allResources(object,keys){var deferred=$q.defer();$q.all(_transferToArray(object,keys)).then(function(){deferred.resolve(object);}).catch(deferred.reject);return deferred.promise;}/**
     * Get a promise ready to be resolved
     *
     * @param  {Object|Array} object  - Result object or list
     * @return {Promise}              - Promise ready to be resolved with the
     *                                  provided object
     * @tested
     */function getResolvedResource(object){var deferred=$q.defer();deferred.resolve(object);return deferred.promise;}/**
     * Get a promise ready to be rejected
     *
     * @param  {Object|Array} object  - Result object or list
     * @return {Promise}              - Promise ready to be rejected with the
     *                                  provided object
     * @tested
     */function getRejectedResource(object){var deferred=$q.defer();deferred.reject(object);return deferred.promise;}/**
     * Transfer object to Array
     *
     * @param  {Object}  obj  - obj to be transfered to array
     * @param  {Array} keys   - array of keys defining wished resources
     *                          to wait for
     *
     * @return {Array}        - Array containing resource promises
     */function _transferToArray(obj,keys){return Object.keys(obj).filter(function(key){if(!ng.isArray(keys)){return true;}return~keys.indexOf(key);}).map(function(prop){return _getAsPromise(obj[prop]);});}function _getAsPromise(resource){return $q.when(resource&&(resource.$promise||resource.promise));}}module.exports=factory;});
